import { store } from '../redux/lib/configureStore.js';

export const messagesMiddleware = () => (next) => (action) => {
  if (['PATCH_MESSAGE_AS_READ', 'PATCH_MESSAGE_AS_UNREAD'].includes(action.type)) {
    const state = store.getState();
    const leadId = (state.messages.allMessages.find((n) => n.unique_id === action.payload) || {}).lead_id;
    action.payload = { leadId, uniqueId: action.payload };
  }
  return next(action);
};
